import './styles.scss';
import React, {Dispatch, useCallback} from "react";

/* types, constants, utils */
import * as Constants from "../../../constants";

/* bootstrap */
import {ToggleButton, ToggleButtonGroup} from "react-bootstrap";

/* redux */
import {AnyAction} from "@reduxjs/toolkit";
import {setViewerRecord, viewPublicRecord} from "../../../redux/slices/viewer-slice";
import {IViewerState} from "../../../types/redux/viewer";
import {RootState} from "../../../redux";
import {useDispatch, useSelector} from "react-redux";

/* components*/
import ViewerMetadata from "../viewer-metadata";
import ViewerCite from "../viewer-cite";
import ViewerTagsNotes from "../viewer-save";
import ViewerDownload from "../viewer-download";
import ViewerShare from "../viewer-share";
import ViewerRecords from "../viewer-records";
import ReportIssue from "../../report-issue";

interface IProps {
  setActiveTool(value:string):void;
}

const ViewerPanel = (props: IProps):JSX.Element => {
  const dispatch:Dispatch<AnyAction> = useDispatch();
  const viewerState: IViewerState = useSelector<RootState, IViewerState>(state => state.viewer);

  const toolPanel = useCallback(():JSX.Element => {
    let tool: JSX.Element;
    switch (viewerState.recordTool) {
      case Constants.METADATA:
        tool = <ViewerMetadata/>
        break;

      case Constants.SEARCH_RESULTS:
      case Constants.BROWSE:
      case Constants.BATES:
      case Constants.MORE_LIKE_THIS:
      case Constants.POSSIBLE_DUPLICATES:
        tool = <ViewerRecords/>
        break;

      case Constants.CITE:
        tool = <ViewerCite/>
        break;

      case Constants.TAGS_NOTES:
        tool = <ViewerTagsNotes/>
        break;

      case Constants.DOWNLOAD:
        tool = <ViewerDownload/>
        break;

      case Constants.SHARE:
        tool = <ViewerShare/>
        break;

      case Constants.REPORT_ISSUES:
        return tool = <div className={'mt-4'}>
          <ReportIssue
            context={Constants.VIEWER}
          />
        </div>;

      default:
        tool = <></>;
    }
    return tool;
  }, [viewerState.recordTool]);

  return (
    <div className={'viewer-panel bg-white h-100 border-end ' + (viewerState.panelCollapsed ? ' hidden': '')}>
      {viewerState.publicRecord &&
        <div className={'border-bottom'}>
          <ToggleButtonGroup
            type="checkbox"
            defaultValue={[1]}
            className={'public-btns m-2'}
          >
            <ToggleButton
              id={'non-public-toggle'}
              value={2}
              className={'ms-1 text-small rounded' + (!viewerState.viewPublicRecord ? ' active': '')}
              onMouseDown={()=> {
                dispatch(setViewerRecord(viewerState.initialRecord))
                dispatch(viewPublicRecord(false))
              }}
            >
              Restricted Version
            </ToggleButton>

            <ToggleButton
              id={'public-toggle'}
              value={1}
              className={'text-small rounded' + (viewerState.viewPublicRecord ? ' active':'')}
              onMouseDown={()=> {
                dispatch(setViewerRecord(viewerState.initialRecord)) /* todo: OIDA-659 isn't this suppose to be a seperate document?*/
                dispatch(viewPublicRecord(true))
              }}
            >
              Public Version
            </ToggleButton>
          </ToggleButtonGroup>
      </div>}

      {toolPanel()}
    </div>
  )
}
export default ViewerPanel;
